import { definePlayerFeature } from "../../feature.js";
import { listen } from "@videojs/utils/dom";
import { isMediaLiveCapable } from "@videojs/media";
//#region src/dom/store/features/live.ts
/**
* Player feature exposing `liveEdgeStart` and `targetLiveWindow` in store state for media that implements
* `MediaLiveCapability` (currently `HlsJsAdapter` and its delegates).
*
* - `liveEdgeStart` — presentation time marking the start of the Live Edge Window. Playing at the live edge when
*   `currentTime >= liveEdgeStart`. `NaN` when the stream isn't live or the value is unknown.
* - `targetLiveWindow` — `0` for standard latency live, `Infinity` for DVR, `NaN` for on-demand or unknown.
*
* Included by the {@link liveVideoFeatures} and {@link liveAudioFeatures} presets; apps can also compose it into a
* custom preset.
*
* @see https://github.com/video-dev/media-ui-extensions/blob/main/proposals/0007-live-edge.md
*/
const liveFeature = definePlayerFeature({
	name: "live",
	state: () => ({
		liveEdgeStart: NaN,
		targetLiveWindow: NaN
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		if (!isMediaLiveCapable(media)) return;
		const sync = () => set({
			liveEdgeStart: media.liveEdgeStart,
			targetLiveWindow: media.targetLiveWindow
		});
		sync();
		listen(media, "targetlivewindowchange", sync, { signal });
		listen(media, "streamtypechange", sync, { signal });
		listen(media, "loadedmetadata", sync, { signal });
		listen(media, "canplay", sync, { signal });
		listen(media, "progress", sync, { signal });
		listen(media, "durationchange", sync, { signal });
		listen(media, "timeupdate", sync, { signal });
		listen(media, "emptied", sync, { signal });
	}
});
//#endregion
export { liveFeature };

//# sourceMappingURL=live.js.map